const sliderTokens = ({ colors, colorsBrand, sizes, space, fontSizeBody }) => ({
  colors: {
    line: colorsBrand[1],
    lineMoved: colors.neutrals[6],
    text: colors.neutrals[1],
    neutralBorder: colors.neutrals[3],
    neutralBorderActive: colors.neutrals[6],
    neutralBg: colors.neutrals[6],
    brandPrimaryActive: colorsBrand[1],
  },
  sizes: {
    default: sizes[2],
    lg: sizes[1],
    defaultActive: sizes[2],
    lgActive: sizes[1],
    sliderRail: '4px',
    sliderTracked: '4px',
  },
  space: {
    textPositionTop: {
      default: space[5],
      lg: space[4],
    },
    stylesLabel: space[5],
  },
  fontSizes: fontSizeBody[0],
  transition: 'background-color 0.2s ease',
});

export default sliderTokens;
